define('app', [
    'domReady',
    'jquery',
    'underscore',
    'backbone',
    'modernizr',
    'detectizr',
    'jquery.happyloader',
    'text!../../json/config.json',
    'utils',
    'modules/form',
    'modules/image-slider',
    'modules/scroll-animate',
    'modules/typeahead',
    'modules/degree-dimming',
    'modules/lazyYT',
    'image-blur-mask-viewer',
    'vision-screening',
    'modules/modal',
    'yandex-map-markers',
    'dragdealer',
    'tipso.min',
    'jquery.scrollTo',
    'velocity',
    'velocity.ui',
    'modules/share',
    'jquery.parallax',
    'jquery.countdown'
],  function ( domReady, $, _, Backbone, Modernizr, Detectizr, Happyloader, config, utils, Form, ImageSlider, ScrollAnimate, Typeahead, DegreeDimming, lazyYT, ImageBlurMaskViewer, VisionScreening, Modal, YandexMapMarkers, Dragdealer, Tipso ) {
    'use strict';

    console.log('%cfile: app.js', 'color: #C2ECFF');

    /** private */
    var _this,
        _defaults = JSON.parse(config),
        modal,
        Router,
        router,
        showProduct,
        showProductDefault,
        productIsInit = false,
        productEnterTransition,
        productSlideTransition,
        productParallaxInstaces = [],
        scrollToCoupon,
        scrollDown,
        transitionsTimesday;

    Router = Backbone.Router.extend({
        routes: {
            'product/:id': 'showProduct',
            '*actions': 'showProductDefault'
        }
    });

    router = new Router();

    if ($('body').length > 1) {
        $('body').eq(0).remove();
    }

    /** constructor
     * @return {boolean}
     */
    function App() {
        console.log('%ctrace: App -> constructor', 'color: #ccc');

        /** public */
        this.options = _.extend({

            },
            _defaults
        );

        _this = this;

        if (window.location.pathname === '/' || window.location.pathname === '/templates/render/main.html') {
            $('body').happyloader({
                debug: true,
                happyloaderBar: 'happy-loader-bar-center',
                callback: function () {
                    console.log('%ctrace: App -> happyloader', 'color: #ccc');

                    $('.js__preloader-cite, .js__preloader-cite-script').remove();

                    new ImageBlurMaskViewer();

                    new ScrollAnimate();

                    scrollDown();
                }
            });
        }

        if (window.location.pathname === '/promo/' || window.location.pathname === '/promo' || window.location.pathname === '/templates/render/promo.html') {
            new Typeahead();
        }

        if (window.location.pathname === '/transitions/' || window.location.pathname === '/transitions' || window.location.pathname === '/templates/render/transitions.html'
            || window.location.pathname.indexOf('crizal-for') >= 0
        ) {
            new DegreeDimming();
            transitionsTimesday();
        }

        utils.shims();

        new Form();
        new ImageSlider();
        new YandexMapMarkers('map');
        modal = new Modal();

        domReady(function () {
            console.log('%ctrace: App -> constructor -> domReady', 'color: #ccc');

            _this.$body = $('body');

            var contentSliderApi = utils.contentSlider();
            utils.accordion();
            utils.imageComparisonSlider();
            utils.uiSlider();
            utils.imageScrollSlider();
            utils.youtubeVideoLoader();
            utils.declOfNum();

            if ( _this.$body.is('.body_state_vision-screening') || window.location.pathname === '/templates/render/vision-screening.html' ) {
                new VisionScreening();
            }

            if ( window.location.pathname === '/promo/' || window.location.pathname === '/promo' || window.location.pathname === '/templates/render/promo.html' ) {
                scrollToCoupon();

                var $countdown = $('[data-countdown]');

                if ($countdown.length <= 0) {
                    return false;
                }

                $countdown.each(function (i, el) {
                    var $el = $(el),
                        finalDate = $el.attr('data-countdown'),
                        $day = $el.find('[data-countdown-unit="day"]'),
                        $hours = $el.find('[data-countdown-unit="hours"]'),
                        $minutes = $el.find('[data-countdown-unit="minutes"]'),
                        $seconds = $el.find('[data-countdown-unit="seconds"]');

                    $el.countdown(finalDate)
                        .on('update.countdown', function(event) {

                            if ($day.length > 0) {
                                $day.html(event.offset.totalDays);
                            }

                            if ($hours.length > 0) {
                                $hours.html(event.offset.hours);
                            }

                            if ($minutes.length > 0) {
                                $minutes.html(event.offset.minutes);
                            }

                            if ($seconds.length > 0) {
                                $seconds.html(event.offset.seconds);
                            }
                        })
                        .on('finish.countdown', function() {

                        });
                });
            }

            if (window.location.pathname === '/products/' || window.location.pathname === '/products' || window.location.pathname === '/templates/render/products.html') {
                //$.scrollTo(document.getElementById('product-nav'), 600);
                router.on('route:showProduct', showProduct);
                router.on('route:showProductDefault', showProductDefault);

                contentSliderApi.renderBeginCallback = function (id) {
                    var $names = $('[data-product-name]'),
                        $lens = $('[data-lens]');

                    $names.removeClass('active');
                    $names.filter('[data-product-name="' + id +'"]').addClass('active');

                    $lens.attr('data-lens', id);

                    $.scrollTo(document.getElementById('product-nav'), 600);

                    window.location.hash = '/product/' + id;

                    productSlideTransition(id, function() {

                    });
                };
            }

            _this.$body.on('mouseenter', '[data-dropdown="btn"]', function() {
                var $menu = $(this).find('[data-dropdown="menu"]');

                $menu.velocity('stop').velocity('transition.slideDownIn', {
                    duration: 300,
                    delay: 0,
                    stagger: 0,
                    mobileHA: true,
                    begin: function(){
                    },
                    complete: function(){
                    }
                });
            });

            _this.$body.on('mouseleave', '[data-dropdown="btn"]', function() {
                var $menu = $(this).find('[data-dropdown="menu"]');

                $menu.velocity('stop').velocity('transition.slideDownOut', {
                    duration: 300,
                    delay: 0,
                    stagger: 0,
                    mobileHA: true,
                    begin: function(){
                    },
                    complete: function(){
                    }
                });
            });

            _this.$body.on('click', '[data-smart-lens-link-light]', function() {
                var $this = $(this),
                    $link = $('[data-smart-lens-link-light]'),
                    $lens = $('[data-smart-lens-light]'),
                    value = $this.attr('data-smart-lens-link-light');

                $link.removeClass('active');
                $this.addClass('active');

                $lens.attr('data-smart-lens-light', value);
            });

            _this.$body.on('click', '[data-smart-lens-link-color]', function() {
                var $this = $(this),
                    $link = $('[data-smart-lens-link-color]'),
                    $lens = $('[data-smart-lens-color]'),
                    value = $this.attr('data-smart-lens-link-color');

                $link.removeClass('active');
                $this.addClass('active');

                $lens.attr('data-smart-lens-color', value);
            });

            /* call when all routes init end */
            Backbone.history.start({pushState: false});
        });
    }

    $('.js__yt-player').lazyYT();

    $('body').on('click', '.js__show-varilux-video', function(event, hideCallback) {
        event.preventDefault();

        var api = $.data($('.js__happymodal-video')[0], 'plugin_happymodal');

        api.options.hideCallback = function(el){
            $('.js__happymodal-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        };

        var modal = 'about-varilux';
        var api = $.data($('[data-happymodal="about-varilux"]')[0], 'plugin_happymodal');
        api.show();

    });

    scrollDown = function scrollDown() {
        $(window).on('scroll', function() {
            var offsetTop = $('.image-blur-mask-viewer').offset().top + $('.image-blur-mask-viewer').height(),
                elementOffsetTop = $('.js__scrolldown').offset().top + $('.js__scrolldown').height() + 20;

            if (elementOffsetTop >= offsetTop && !$('.js__scrolldown').is('faded')) {
                $('.js__scrolldown').addClass('faded');
            } else {
                $('.js__scrolldown').removeClass('faded');
            }
        })
    };

    transitionsTimesday = function transitionsTimesday() {
        var $container = $('.transitions-advantage__timesday'),
            $sun = $('.transitions-advantage__timesday-sun'),
            $lens = $('.transitions-advantage__smart-lens-rim .smart-lens__lens'),
            h = 330 - 90;

        new Dragdealer('dragdealer', {
            horizontal: false,
            vertical: true,
            y: 0,
            animationCallback: function (x, y) {
                var opacity = 1 - y;

                if (opacity >= 0.8) {
                    opacity = 0.8;
                }

                if (opacity <= 0.2) {
                    opacity = 0.2;
                }

                $sun.css('top', y * h);
                $lens.css('opacity', opacity);
            }
        });
    };

    scrollToCoupon = function scrollToCoupon() {
        $('body').on('click', 'a[href="#/get-coupon"]', function(event) {
            event.preventDefault();

            $(window).scrollTop($('#action').offset().top);
            $('#coupon-name').focus();

            return false;
        });
    };

    $('.js-show-tip').tipso({
        speed: 150,
        width: 330,
        background: '#eaeaea',
        color: '#2e76ab',
        position: 'bottom',
        tooltipHover: true
    });

    $('.js-scroll-hash').click(function () {
        $.scrollTo(this.hash, 600);
        return false;
    });

    productEnterTransition = function productEnterTransition(id, callback) {
        var $lens = $('.js__animate-layer .lens__ill').not('.lens_base');
        var $caption = $('.lens__caption');
        var $baseLens = $('.js__animate-layer .lens_base');
        var lensOrigianlPos = [];
        var lensAnimation = [];
        var lensScales = [1.1, 1.1, 1, 0.9, 0.9, 0.8, 0.8];

        var timeline = {
            baseLens: {
                opacity: 150
            },
            lens: {
                delay: 1000,
                stagger: 80,
                opacity: 150,
                translate: 1200
            },
            fadeIn: 300
        };

        $lens = $lens.filter(function(i, el) {
            var $el = $lens.eq(i);
            var slides = [];

            if ($el.attr('data-lens-group')) {
                slides = JSON.parse($el.attr('data-lens-group'));
            }

            return slides.indexOf(id) >= 0;
        });

        $caption = $caption.filter(function(i, el) {
            var $el = $caption.eq(i);
            var slides = [];

            if ($el.attr('data-lens-group')) {
                slides = JSON.parse($el.attr('data-lens-group'));
            }

            return slides.indexOf(id) >= 0;
        });

        $baseLens.parents('.lens__ill-wrapper').css('opacity', 1);
        $lens.parents('.lens__ill-wrapper').css('opacity', 1);

        var lensPostionSet = function() {
            var baseLensPoint = {
                top: $baseLens.position().top + $baseLens.height() / 2,
                left: $baseLens.position().left + $baseLens.width() / 2
            };

            $lens.each(function(i, el) {
                lensOrigianlPos.push({
                    top: $lens.eq(i).position().top,
                    left: $lens.eq(i).position().left
                });

                $lens.eq(i).css('top', baseLensPoint.top - $lens.eq(i).height() / 2);
                $lens.eq(i).css('left', baseLensPoint.left - $lens.eq(i).width() / 2);
                //$lens.eq(i).css('transform', 'scale(' + lensScales[i] + ')');

                var delay = timeline.lens.stagger;
                var queue = false;

                if (i === 0) {
                    delay = timeline.lens.delay;
                    queue = undefined;
                }

                lensAnimation.push({
                    elements: $lens.eq(i),
                    properties: {
                        opacity: 1
                    },
                    options: {
                        duration: timeline.lens.opacity,
                        delay: delay,
                        sequenceQueue: queue,
                        queue: queue,
                        begin: function() {
                        },
                        complete: function() {
                        }
                    }
                });
                lensAnimation.push({
                    elements: $lens.eq(i),
                    properties: {
                        top: lensOrigianlPos[i].top,
                        left: lensOrigianlPos[i].left,
                        scale: 1
                    },
                    options: {
                        duration: timeline.lens.translate,
                        delay: 0,
                        sequenceQueue: false,
                        queue: false,
                        easing: [.43,.44,0,.66],
                        begin: function() {
                        },
                        complete: function() {
                            $lens.eq(i).css('top', '');
                            $lens.eq(i).css('left', '');
                            $lens.eq(i).css('transform', '');

                            if (i === $lens.length - 1) {
                                $('.product').addClass('js-productEnterTransitionEnd');
                                $('.lens__ill').css('opacity', 1);

                                var $fadeIn = $('.js__animate-fadeIn').add($caption);

                                $fadeIn.velocity({
                                    opacity: 1
                                }, {
                                    duration: timeline.fadeIn
                                });

                                callback();
                            }
                        }
                    }
                });
            });
        };

        var animation = [
            {
                elements: $baseLens,
                properties: { opacity: 0 },
                options: {
                    duration: 0,
                    begin: function() {
                    }
                }
            },
            {
                elements: $baseLens,
                properties: { opacity: 1 },
                options: {
                    duration: timeline.baseLens.opacity,
                    delay: 0,
                    begin: function() {
                    },
                    complete: function() {
                    }
                }
            }
        ];

        lensPostionSet();
        animation = animation.concat(lensAnimation);
        $.Velocity.RunSequence(animation);
    };

    productSlideTransition = function productSlideTransition(id, callback) {
        var $lens = $('.lens__ill');
        var $caption = $('.lens__caption');
        var x0 = 0,
            x1 = 100,
            y0 = 0,
            y1 = 20;

        var timeline = {
            flash: {
                duration: 90
            },
            caption: {
                fadeOut: 300,
                fadeIn: 300
            },
            lens: {
                fadeOut: {
                    translate: 350,
                    opacityDuration: 150
                },
                fadeIn: {
                    translate: 1900,
                    opacityDuration: 150
                }
            }
        };

        var flashAnimate = function($el, removecss, cb) {

            if (typeof removecss == 'undefined') {
                removecss = true;
            }

            cb = cb || function() {};

            var flashAnimateSequence = [
                {
                    elements: $el,
                    properties: { opacity: 0 },
                    options: {
                        duration: timeline.flash.duration
                    }
                },
                {
                    elements: $el,
                    properties: { opacity: 1 },
                    options: {
                        duration: timeline.flash.duration
                    }
                },
                {
                    elements: $el,
                    properties: { opacity: 0 },
                    options: {
                        duration: timeline.flash.duration
                    }
                },
                {
                    elements: $el,
                    properties: { opacity: 1 },
                    options: {
                        duration: timeline.flash.duration,
                        complete: function() {
                            if (removecss) {
                                $el.css('opacity', '');
                            }

                            cb();
                        }
                    }
                }
            ];

            $.Velocity.RunSequence(flashAnimateSequence);
        };

        $lens.each(function(i, el) {
            var $el = $lens.eq(i);
            var $animateEl = $el.parents('.lens__ill-wrapper');
            var slides = [];

            if ($el.attr('data-lens-group')) {
                slides = JSON.parse($el.attr('data-lens-group'));
            }

            if ($.Velocity.hook($animateEl, 'translateX') === x0 && $.Velocity.hook($animateEl, 'opacity') < 1) {
                $.Velocity.hook($animateEl, 'translateX', x1 + 'px');
                $.Velocity.hook($animateEl, 'translateY', y1 + 'px');
            }

            if (slides.indexOf(id) < 0) {
                lensFadeOut($animateEl);
            }

            if (slides.indexOf(id) >= 0) {
                lensFadeIn($animateEl);
            }
        });

        $caption.each(function(i, el) {
            var $el = $caption.eq(i);
            var $animateEl = $el;
            var slides = [];

            if ($el.attr('data-lens-group')) {
                slides = JSON.parse($el.attr('data-lens-group'));
            }

            if (slides.indexOf(id) < 0) {
                $animateEl.velocity({
                    opacity: 0
                }, {
                    duration: timeline.caption.fadeOut
                });

                $animateEl.find('.js__animate-flash').velocity('stop');
            }

            if (slides.indexOf(id) >= 0) {
                var isFlashing = false;

                $animateEl.velocity({
                    opacity: 1
                }, {
                    duration: timeline.caption.fadeIn,
                    begin: function() {
                        if ($.Velocity.hook($animateEl, 'opacity') >= 1) {
                            isFlashing = true;
                        }
                    },
                    complete: function() {
                        if (!isFlashing) {
                            flashAnimate($animateEl.find('.js__animate-flash'))
                        }
                    }
                });
            }
        });

        function lensFadeOut($el) {
            $el.velocity('stop');

            $el.velocity({
                translateX: x1,
                translateY: y1
            }, {
                duration: timeline.lens.fadeOut.translate,
                easing: [.43, .44, 0, .66],
                complete: function () {
                    if ($.Velocity.hook($el, 'opacity') >= 1) {
                        flashAnimate($el);
                    }
                }
            });

            /*$el.velocity({
                opacity: 0
            }, {
                duration: timeline.lens.fadeOut.opacityDuration,
                easing: [0,0,1,1]
            });*/
        }

        function lensFadeIn($el) {
            $el.velocity('stop');

            /*$el.velocity({
                opacity: 1
            }, {
                duration: timeline.lens.fadeIn.opacityDuration,
                easing: [0,0,1,1]
            });*/

            if ($.Velocity.hook($el, 'opacity') < 1) {
                flashAnimate($el, false, function() {
                    $el.velocity({
                        translateX: x0,
                        translateY: y0
                    }, {
                        duration: timeline.lens.fadeIn.translate,
                        easing: [.43,.44,0,.66]
                    });
                });
            }
        }
    };

    showProductDefault = function showProductDefault(actions) {
        showProduct('easy-uv');
    };

    showProduct = function showProduct(id) {
        if (!productIsInit) {
            productEnterTransition(id, function() {
                $('[data-parallax]').each(function(i, el){
                    var options = $(el).attr('data-parallax-options');

                    if (options) {
                        options = JSON.parse($(el).attr('data-parallax-options'));
                    }

                    var instance = $(el).parallax(options);
                    productParallaxInstaces.push(instance);
                });
            });

            productIsInit = true;
        }

        var $names = $('[data-product-name]'),
            $lens = $('[data-lens]'),

            $wrap = $('[data-content-slider-wrap]'),

            $item = $('[data-content-slider-item]'),
            $currentItem = $item.filter('[data-content-slider-item="' + id + '"]'),

            $link = $('[data-content-slider-link]'),
            $currentLink = $link.filter('[data-content-slider-link="' + id + '"]'),

            $prev = $('[data-content-slider-prev]'),
            $next = $('[data-content-slider-next]'),

            itemsLength = $item.length,
            nextItemIndex = $item.index($currentItem),
            prev = $item.eq(nextItemIndex - 1).attr('data-content-slider-item'),
            next = $item.eq(nextItemIndex + 1).attr('data-content-slider-item');

        $currentLink.addClass('active');
        $link.not($currentLink).removeClass('active');

        if ($names.filter('[data-product-name="' + id +'"]').is('.active')) {
            return false;
        }

        $item.removeClass('active');
        $currentItem.addClass('active');

        if (nextItemIndex >= itemsLength - 1) {
            next = $item.eq(0).attr('data-content-slider-item');
        }

        if (nextItemIndex === 0) {
            prev = $item.eq(itemsLength - 1).attr('data-content-slider-item');
        }

        $prev.attr('data-content-slider-prev', prev);
        $next.attr('data-content-slider-next', next);

        $wrap.css('height', $currentItem.outerHeight());

        $names.removeClass('active');
        $names.filter('[data-product-name="' + id +'"]').addClass('active');

        $lens.attr('data-lens', id);
    };

    return App;
});

